import { Link, Paragraph, Text, Title, TypographyRoot } from "./Typography";

/** `Typography.Text` usw. wie bei Antd; `<Typography>` selbst ist der Lesesatz-Container. Eigene Datei, damit `Typography.tsx` nur Komponenten exportiert. */
export const Typography = Object.assign(TypographyRoot, { Text, Title, Paragraph, Link });
